export function baseUrl(): string {
    return `/clinicportal/ng/`;
}
export function ApiHostName(): string {
    //return 'http://workforce-test.formfox.com';
    const baseDomain = window.location.hostname;
    const firstDotIndex = baseDomain.indexOf('.');
    const domain = baseDomain.substring(firstDotIndex + 1);
    return (`${window.location.protocol}//${domain}${window.location.port ? `:${window.location.port}` : ""}`);
    //return "http://localhost:49924";
}

export default function ApiUrl(): string {
    //return 'http://workforce-test.formfox.com/mcpwebapi/api/';
    return (`${ApiHostName()}/mcpwebapi/api/`);
    //return `${ApiHostName()}/api/`;
}

export function ApiRootUrl(): string {
    //return 'http://workforce-test.formfox.com/mcpwebapi/';
    return (`${ApiHostName()}/mcpwebapi`);
    //return `${ApiHostName()}`;
}

export function FullBaseUrl(): string {
    const baseDomain = window.location.origin;
    return `${baseDomain}${baseUrl()}#`;
}

export function PortalSource(): string{
    const baseDomain = window.location.hostname;
    const firstDotIndex = baseDomain.indexOf('.');
    return baseDomain.substring(0, firstDotIndex);
}
